import { ca } from '@cian/analytics';

import { CAROUSEL_PLACE } from '../constants';

export function trackSpecialPromosDataReceived({ viewType }: { viewType: 'carousel' | 'banner' }): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'received',
    label: 'specproject',
    page: {
      extra: {
        is_specproject: true,
        view_type: viewType,
        carousel_place: CAROUSEL_PLACE,
      },
    },
  });
}
